import React from 'react';

interface ListIconProps {
  className?: string;
  color?: string;
  size?: number;
}

const ListIcon: React.FC<ListIconProps> = ({ className = '', color = '#A2876E', size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path
        d="M9.58984 6.5H20.85M9.58984 12.5H20.85M9.58984 18.5H20.85M4.34961 6.50049H5.84961M4.34961 12.5005H5.84961M4.34961 18.5005H5.84961"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ListIcon;
